export default __webpack_public_path__ + "static/ai-solutions-with-roadmap1--mobile-daee1e62314a361d07e4291505592745.jpg";